module.exports = __webpack_public_path__ + "img/build-in-2020-1.c87a1fe7.jpg";